import React from 'react';

import styles from './SmallDestinationCard.module.css';

const SmallDestinationCard = ({ location, price, image }) => {
    return(
        <div className={styles.SmallDestinationCardWrapper}>
           <img src={image} alt="" />
           <h4 className={styles.SmallDestinationCardLocation}>{location}</h4>
           <p className={styles.SmallDestinationCardPrice}>{`From $${price}`}</p>
        </div>
    )
}

export default SmallDestinationCard;



// WEBPACK FOOTER //
// ./src/components/SmallDestinationCard/SmallDestinationCard.jsx